import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { ItemStructure } from 'src/app/models/domain';

@Component({
  selector: 'em-ed-revision-structure',
  templateUrl: './ed-revision-structure.component.html',
  standalone: false,
})
export class EDRevisionStructureComponent {
  @Input() public elementDesignStructure?: ItemStructure;
  @Input() public error = '';
  public readonly trackByRef = trackByRef;
}
